import { Fill, Stroke, Style, Text } from 'ol/style';
const minSize = 12; // Minimum font size
const maxSize = 12; // Maximum font size
export function buoyStyle(name: string, res: number, isLightBuoy: boolean = false) {
  const fontSize = Math.max(minSize, Math.min(maxSize, 20 / res)); // Scale text within limit
  const isFarOut = res > 2.5;

  return new Style({
    zIndex: 2,
    fill: new Fill({
      color: isLightBuoy ? '#ff917c' : '#06232d',
    }),
    stroke: new Stroke({
      color: isLightBuoy ? '#a25f52' : '#0e4959',
      width: 2, // Border width
    }),
    text: isFarOut
      ? undefined
      : new Text({
          font: `${fontSize}px Arial, sans-serif`, // Font size and family
          offsetY: 0, //-Math.max(minSize, Math.min(17, 20 / res)),
          scale: 1,
          overflow: true,
          text: name, // The label to display
          fill: new Fill({
            color: isLightBuoy ? '#0e4959' : 'white', // Text color
          }),
          textAlign: 'center', // Align text to the center
          textBaseline: 'middle', // Vertically center the text
        }),
  });
}
